import {
  Download,
  GetVideoByIdQuery,
  useGetVideoByIdQuery,
} from 'generated/graphql';
import { useEffect, useState } from 'react';

export enum VideoStatus {
  ProcessingStarted = 'PROCESSING_STARTED',
  ProcessingEncodeFinished = 'PROCESSING_ENCODE_FINISHED',
  ProcessingFinished = 'PROCESSING_FINISHED',
  ProcessingError = 'PROCESSING_ERROR',
  UploadStarted = 'UPLOAD_STARTED',
  UploadFinished = 'UPLOAD_FINISHED',
}

export type VideoById = GetVideoByIdQuery['getVideoById'];

export const useUpload = ({
  influencerId,
  uploadedId,
  addVideo,
}: {
  influencerId: number;
  uploadedId: string | null;
  addVideo: (video: VideoById) => void;
}) => {
  const [uploadFinished, setUploadFinished] = useState(false);
  const { data, client, startPolling } = useGetVideoByIdQuery({
    variables: {
      creatorId: influencerId,
      videoId: uploadedId || '',
      videoSourceType: 'mux',
    },
    fetchPolicy: 'network-only',
    skip: uploadedId === null,
  });

  useEffect(() => {
    if (
      data?.getVideoById?.status &&
      data?.getVideoById?.status === VideoStatus.ProcessingError
    ) {
      console.error('Something went wrong');
    }

    if (
      uploadedId &&
      (!data?.getVideoById?.status ||
        data?.getVideoById?.status !== VideoStatus.ProcessingFinished)
    ) {
      startPolling(3000);
    }
    if (
      data?.getVideoById?.status &&
      data?.getVideoById?.status === VideoStatus.ProcessingFinished
    ) {
      setUploadFinished(true);
      data?.getVideoById && addVideo(data.getVideoById);
      client.stop();
    }

    return () => {
      client.stop();
    };
  }, [data, client, addVideo]);

  return {
    uploadFinished,
    startPolling,
  };
};
